export default "__VITE_ASSET__D0l6oKuQ__"